import React, {useState, useCallback} from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import Loading from '../../../components/loading';
import PlayerSearch from '../../../components/search-autocomplete/PlayerSearch';
import {getTopicsInPlayer} from '../../../actions/my-topic';
import useDisableScrollDocument from '../../../useHook/useDisableScrollDocument';

import './game-modal.scss';

function GameModal(props) {
    useDisableScrollDocument();

    const {onClose, onSave} = props;
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [listTopic, setListTopic] = useState([]);
    const [selectedTopic, setSelectedTopic] = useState(null);

    const onSelectPlayer = useCallback(async (player) => {
        setLoading(true);
        const response = await dispatch(getTopicsInPlayer(player.id));
        setLoading(false);
        setListTopic(response);
    }, [])

    return <div className="game-modal-wrap-select-game">
        <div className="select-game-info">
            <h4>既存Topicsから追加</h4>
            <div className={'body-container'}>
                <div className={'search-wrapper'}>
                    <PlayerSearch
                        placeholder=''
                        onPlayerClick={onSelectPlayer}
                    />
                </div>
                <div className={'modal-game-list-topic'}>
                    {listTopic.map((topic) => {
                        const active = selectedTopic && selectedTopic.id === topic.id;
                        return <div key={topic.id}
                                    className={classNames('topic-item', active && 'topic-active')}
                                    onClick={() => setSelectedTopic(topic)}
                        >
                            {topic.title && <span style={{paddingRight: 10}}>{topic.title}</span>} {topic.player && <span style={{color: '#999999'}}>
                                {topic.player.player_name}
                            </span>}
                        </div>
                    })}
                </div>
            </div>
            <div className={'footer-wrapper'}>
                <button onClick={onClose}>キャンセル</button>
                <button disabled={!selectedTopic} onClick={() => onSave(selectedTopic)}>決定</button>
            </div>
        </div>
        <Loading show={loading}/>
    </div>
}

export default GameModal;
